import Icon from '@ant-design/icons';
import styled from 'styled-components';
import DefaultIcon from '../../icons/defaultCloseIcon.svg';
import { CloseButtonCss } from '../default/CloseButton';
import LocalButton from './Button';

const Button = styled(LocalButton)`
    ${CloseButtonCss}
`;

const CloseButton = props => <Button {...props} icon={<Icon component={DefaultIcon} />} />;

export default CloseButton;
